import { render, staticRenderFns } from "./ConfigurationOAuth.vue?vue&type=template&id=2a7f16e6&scoped=true&"
import script from "./ConfigurationOAuth.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationOAuth.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationOAuth.vue?vue&type=style&index=0&id=2a7f16e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f16e6",
  null
  
)

export default component.exports